import React, { useEffect, useState } from 'react';
import News from '../../../Components/news';
import { Search } from '../../../../assets/img/svg/icons';
import Pagination from '../../../Components/pagination';
import { fetchData } from '../../../../Api';
import { PostInterface } from '../../../Services/types';

const ListSection: React.FC<any> = ({initialData} : any) => {
    function proccessPosts()
    {
        if(initialData == null || initialData?.posts === undefined){
            return [];
        }
        const formattedPosts = initialData?.posts.map((post: PostInterface) => ({
            ...post,
            data: new Date(post.data),
        })) ?? [];

        return formattedPosts;
    }

    const [posts, setPosts] = useState<PostInterface[]>(proccessPosts());
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [max, setMax] = useState(1);

    const loadData = async () => {
        const response = await fetchData(`noticias?search=${search}&page=${page}`);
        if(response){
            if (response.posts) {
                const formattedPosts = response.posts.map((post: PostInterface) => ({
                    ...post,
                    data: new Date(post.data),
                }));
                setPosts(formattedPosts);
            }
            if (response.max) setMax(response.max);
        }
    };

    useEffect(() => {      
      loadData();
    }, [page]);

    const formSubmit = async (e:any) => {
        e.preventDefault()
        setPage(1);
        loadData();
    }
    
    return (
        <section className='pt-4 pb-12'>
            <div className="max-w-screen-lg mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4 justify-between mb-10 pt-4 md:pt-0">
                    <h2 className="font-semibold text-2xl text-balance text-center md:text-left">
                        Notícias e novidades
                    </h2>

                    <form action="" onSubmit={(e) => {formSubmit(e)}}>
                        <label htmlFor="search" className='relative flex justify-end items-end'>
                            <input type="text" name='search' id='search' onChange={(e) => setSearch(e.target.value)} value={search} placeholder='O que você Procura?' className='w-full md:w-2/3 pr-12 border border-black/20 rounded-full text-sm py-2 px-4 outline-none' />

                            <button type="submit" className='absolute right-4 top-2'>
                                <Search className='w-5 h-5 object-contain'/>
                            </button>
                        </label>
                    </form>
                </div>

                <div className="grid md:grid-cols-6 gap-x-8 gap-y-8 md:gap-y-20 max-w-screen-lg mx-auto">
                    {posts.length > 0 ? posts.map((post, index: any) => (
                        <News 
                            key={post.id}
                            title={post.titulo} 
                            excerpt={post.excerpt} 
                            date={post.data} 
                            slug={post.slug} 
                            thumbnail={post.thumbnail}  
                            className={index >= 2 && index <= 4 ? 'md:col-span-2' : 'md:col-span-3'} 
                            type={index >= 2 && index <= 4 ? 'simple' : ''}
                        />
                    )) : 
                        <div className='text-center md:col-span-6'>Nenhum post encontrado</div>
                    }
                </div>

                <div className="mt-12">
                    <Pagination page={page} max={max} setPage={setPage}/>
                </div>
            </div>
        </section>
    );
};

export default ListSection;